import React from 'react'

const NotificationCreationPage = () => {
  return <h1>Notification creation</h1>
}

export default NotificationCreationPage
